//Modal component to show content in a popup
import React from 'react';
import styles from '../css/modal.module.css';

export default function Modal({ isOpen, onClose, children, printIt }) {
  if (!isOpen) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button onClick={onClose} className={styles.closeButton}>
          X
        </button>
        {children}
      </div>
    </div>
  );
}
